import React from 'react';

const PdfIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="48"
    height="48"
    fill="#e53935"
    {...props}
  >
    <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9.5 14.5v-1H11v.5h2v-1h.5v-1h-2v-.5H9.5v1H8v1h1.5zM18 12.5h-5v-1h5v1zm0-2.5h-5v-1h5v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z" />
  </svg>
);

export default PdfIcon;